







import ProgressBar from '@/components/ui/ProgressBar.vue';
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { currentInstance, localeList } from '@/heplers';
import CookieBannerOptions from '@/plugins/cookieBanner';
import CookieBannerOptionsRu from '@/plugins/cookieBannerRu';
import { LocaleItem } from '@/templates/DataNames';
import { ONE_WEEK } from './constants/common';

@Component({
  components: {
    ProgressBar,
  },
  metaInfo() {
    return {
      title: (this as any).getTitleApp as string,
      titleTemplate: (this as any).titleTemplate as string,
      meta: [
        { charset: 'utf-8' },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1, shrink-to-fit=no',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: (this as any).canonicalUrl,
        },
      ],
      __dangerouslyDisableSanitizers: ['title', 'titleTemplate'],
    };
  },
})
export default class App extends Vue {
  showUpdateButton = false;
  $gtm: any;
  public currentLocale: LocaleItem = localeList[0];
  langRu = [process.env.VUE_APP_LANG, process.env.VUE_APP_PROD_LANG].includes('ru');

  get getTitleApp() {
    let docLocaleVox = this.langRu ? `Документация Voximplant | ` : `Voximplant Documentation | `;
    let docLocaleKit = this.langRu
      ? `Документация Voximplant Kit | `
      : `Voximplant Kit Documentation | `;
    return currentInstance === 'vox' ? `${docLocaleVox}` : `${docLocaleKit}`;
  }

  get canonicalUrl() {
    return 'https://voximplant.com' + this.$route.path;
  }

  get titleTemplate() {
    let locale = this.langRu ? 'Voximplant.ru' : 'Voximplant.com';
    return `${this.getTitleApp}${currentInstance === 'kit' ? `Voximplant Kit | ` : ''}${locale}`;
  }

  async mounted() {
    this.loadScripts(
      'https://www.google.com/recaptcha/api.js?render=6LexrqElAAAAAN8LzgfirBnWAZ-aB33E8fXrTr4q'
    );

    if (window) {
      // @ts-expect-error: cookie-banner.js is not module
      await import('@/plugins/cookie-banner.js');
      this.initCookieBanner();
    }
  }

  private callback = (cb: string) => {
    // clear all cookies except with_by_link
    document.cookie.split(';').forEach((c) => {
      const cookieName = c.replace(/^ +/, '').split('=')[0];
      // Skip application functional cookies
      if (cookieName === 'with_by_link') return;

      const newCookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
      document.cookie = newCookie;
      document.cookie = `${newCookie};domain=.voximplant.com;`;
      document.cookie = `${newCookie};domain=.voximplant.ru;`;
      document.cookie = `${newCookie};domain=voximplant.ru;`;
      document.cookie = `${newCookie};domain=voximplant.com;`;
    });
    // start gtm services
    if (cb.includes('analytics_cookies') && !this.$gtm.enabled()) {
      this.$gtm.enable(true);
    }

    if (cb.includes('functionality_cookies')) {
      const withByLinkFromQuery = this.$route.query.with_by_link;

      if (withByLinkFromQuery && typeof withByLinkFromQuery === 'string') {
        document.cookie = `with_by_link=${encodeURIComponent(
          String(withByLinkFromQuery)
        )}; Max-Age=${ONE_WEEK}; Path=/; Secure; SameSite=lax`;
      }
    }
  };

  private initCookieBanner = () => {
    return this.langRu
      ? new window.Cookiebanner(CookieBannerOptionsRu, this.callback)
      : new window.Cookiebanner(CookieBannerOptions, this.callback);
  };
  private loadScripts(src: string) {
    let script = document.createElement('script');
    script.setAttribute('src', src);
    script.setAttribute('async', 'async');
    document.head.appendChild(script);
  }
}
